import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import StarRatings from 'react-star-ratings';
import './StaffinoWidget.scss';
import likeIcon from '../assets/images/like.svg';
import dislikeIcon from '../assets/images/dislike.svg';
var StaffinoWidget = function (props) {
    var initial_data = useSelector(function (state) { var _a, _b; return (_b = (_a = state === null || state === void 0 ? void 0 : state.domain) === null || _a === void 0 ? void 0 : _a.arbitrary) === null || _b === void 0 ? void 0 : _b.initial_data; });
    var handleSubmit = props.handleSubmit, handleCancel = props.handleCancel, onModalVariantChange = props.onModalVariantChange;
    var _a = useState(false), show = _a[0], setShow = _a[1];
    var _b = useState(false), kind = _b[0], setKind = _b[1];
    var _c = useState(), firstTime = _c[0], setFirstTime = _c[1];
    var _d = useState(0), rating = _d[0], setRating = _d[1];
    useEffect(function () {
        if (show && onModalVariantChange) {
            onModalVariantChange('staffino-show-form');
        }
        else if (onModalVariantChange) {
            onModalVariantChange && onModalVariantChange('staffino');
        }
    }, [show, onModalVariantChange]);
    var setShowRestOfForm = function (showPositive) {
        setKind(showPositive);
        setShow(true);
    };
    var initialValues = {
        kind: '',
        firstTime: '',
        text: '',
        stars: null,
    };
    var validate = function (values) {
        var errors = {};
        if (values.text.trim().length < 1 && !kind) {
            errors.text = 'Povinné';
        }
        // mandatory for both kind and !kind
        if (typeof values.firstTime !== 'boolean') {
            errors.firstTime = 'Povinné';
        }
        // mandatory for both kind and !kind
        if (!values.stars) {
            errors.stars = 'Povinné';
        }
        return errors;
    };
    // "venue": {"id": "sazka-uat"} - "sazka-uat" pre uat, "sazka-lb" pre location "https://extranet.uat.sazka.cz", "sazka-deh" pre location "https://sazka.cz" alebo "https://sazka.cz/sazka-klub"
    var getVenue = function (location) {
        if (!location)
            return 'location is not defined';
        var venue = 'sazka-uat';
        if (location.includes('uat.sazka.cz'))
            venue = 'sazka-uat';
        else if (location.includes('extranet.sazka.cz'))
            venue = 'sazka-lb';
        else if (location.includes('www.sazka.cz') ||
            location.includes('sazka.cz/sazka-klub'))
            venue = 'sazka-deh';
        return venue;
    };
    var formik = useFormik({
        initialValues: initialValues,
        validate: validate,
        onSubmit: function (_a) {
            var kind = _a.kind, text = _a.text, first = _a.firstTime, stars = _a.stars;
            var payload = {
                kind: kind ? 'thank-you' : 'suggestion',
                text: text,
                venue: { reference: getVenue(initial_data.Location) },
                answers: [],
            };
            first !== '' &&
                payload.answers.push({
                    question_id: '41906787-584e-438d-a157-1cc24b817c39',
                    choices: [
                        {
                            choice_id: first
                                ? '5c2fb8b6-8e03-4831-9f56-7b25288d4abe'
                                : 'cf0784ac-874f-48b8-b284-1ccf8588bf68',
                        },
                    ],
                });
            stars !== null &&
                payload.answers.push({
                    question_id: '1bcaa030-41c0-40c9-8092-63b6d1bcdd76',
                    score: stars,
                });
            handleSubmit(payload);
        },
    });
    var setStars = function (value) {
        setRating(value);
        formik.values.stars = value;
    };
    var setFirstTimeValue = function (e, value) {
        values.firstTime = value;
        setFirstTime(value);
        handleChange(e);
        validateForm();
    };
    var errors = formik.errors, values = formik.values, handleChange = formik.handleChange, validateForm = formik.validateForm, submitForm = formik.submitForm, resetForm = formik.resetForm, isSubmitting = formik.isSubmitting, setErrors = formik.setErrors;
    var _renderRestOfForm = function () {
        var textareaPlaceholder = 'Napište nám, prosím, jaká byla vaše zkušenost.';
        if (!show)
            return null;
        return (React.createElement("div", { className: "center flex column" },
            React.createElement("div", { className: "mb-24 mt-8 flex column" },
                React.createElement("textarea", { placeholder: textareaPlaceholder, value: values.text, name: "text", id: "text", onChange: handleChange, className: errors.text && 'error' }),
                errors.text && React.createElement("span", { className: "error" }, errors.text)),
            React.createElement("div", { className: "mb-24 first-time" },
                React.createElement("p", { className: "mb-8" }, "Byl v\u00E1\u0161 po\u017Eadavek vy\u0159e\u0161en napoprv\u00E9?"),
                React.createElement("div", { className: "flex" },
                    React.createElement("div", { className: "mr-8 like-btn" },
                        React.createElement("button", { className: "btn ".concat(firstTime && 'selected'), onClick: function (e) { return setFirstTimeValue(e, true); } },
                            React.createElement(LikeIcon, { selected: !!firstTime }),
                            "Ano")),
                    React.createElement("div", { className: 'dislike-btn' },
                        React.createElement("button", { className: "btn dislike ".concat(firstTime === false && 'selected'), onClick: function (e) { return setFirstTimeValue(e, false); } },
                            React.createElement(LikeIcon, { dislike: true, selected: firstTime === false }),
                            "Ne"))),
                errors.firstTime && (React.createElement("div", null,
                    React.createElement("span", { className: "error" }, errors.firstTime)))),
            React.createElement("p", { className: "mb-24" }, "Jak jste byl/a spokojen/a s p\u0159\u00EDstupem specialisty?"),
            React.createElement("div", { className: "mb-24" },
                React.createElement(StarRatings, { rating: rating, starRatedColor: "#27E2CC", starHoverColor: "#27E2CC", starEmptyColor: "none", starDimension: "24px", svgIconPath: "M7.93558 13.445C8.37582 13.8987 8.5756 14.5339 8.47438 15.158L7.83672 19.089L11.0285 17.3148C11.6327 16.9789 12.3676 16.9789 12.9719 17.3148L16.1636 19.089L15.526 15.158C15.4248 14.5339 15.6245 13.8987 16.0648 13.445L18.8664 10.5575L15.0956 9.97813C14.4355 9.8767 13.8696 9.45244 13.5871 8.84724L12.0002 5.44747L10.4133 8.84724C10.1308 9.45245 9.56486 9.8767 8.90471 9.97813L5.13392 10.5575L7.93558 13.445Z", svgIconViewBox: "0 0 24 24", onChange: function (e) {
                        handleChange(e);
                        validateForm();
                    }, changeRating: function (newRating) {
                        setStars(newRating);
                        validateForm();
                    }, numberOfStars: 5, name: "rating" }),
                React.createElement("br", null),
                errors.stars && React.createElement("span", { className: "error" }, errors.stars)),
            React.createElement("button", { type: "submit", disabled: isSubmitting, className: "btn btn-submit", onClick: function (e) {
                    e.preventDefault();
                    if (validateForm(values))
                        submitForm();
                } }, "Odeslat dotazn\u00EDk")));
    };
    return (React.createElement("form", { className: "staffino-widget flex center column", onSubmit: function (e) {
            e.preventDefault();
        } },
        React.createElement("h5", { className: "mt-10" },
            "Jak\u00E1 byla zku\u0161enost s na\u0161\u00EDm ",
            React.createElement("br", null),
            "specialistou?"),
        React.createElement("div", { className: "flex mt-16 mb-16" },
            React.createElement("button", { className: "btn mr-8 ".concat(kind && 'selected'), onClick: function () {
                    setErrors({});
                    values.kind = true;
                    setShowRestOfForm(true);
                } }, "Chci pochv\u00E1lit"),
            React.createElement("button", { className: "btn ".concat(!kind && show && 'selected'), onClick: function () {
                    values.kind = false;
                    setShowRestOfForm(false);
                } }, "M\u00E1m p\u0159ipom\u00EDnku")),
        _renderRestOfForm(),
        React.createElement("button", { className: "cancel", onClick: function () {
                resetForm();
                handleCancel();
            } }, "Zav\u0159\u00EDt chat bez hodnocen\u00ED")));
};
var LikeIcon = function (_a) {
    var _b = _a.dislike, dislike = _b === void 0 ? false : _b, _c = _a.selected, selected = _c === void 0 ? false : _c;
    var src = dislike ? dislikeIcon : likeIcon;
    return React.createElement("img", { src: src, className: "like-icon ".concat(selected ? 'selected' : '', " ").concat(dislike ? 'dislike' : '') });
};
export default StaffinoWidget;
